import React, {useState} from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import {BasicSearchType} from "../../../../types/common/basic";
import EmptyTableRow from "../../../../pages/common/EmptyTableRow";
import {ModalInnerConfirmType} from "../interface";
import {useModal} from "../../../../hooks";
import PaginationSub from "../../pagination/PaginationSub";
import useReadStnd from "../../../../pages/support/rma/hooks/useReadStnd";
import {StdType} from "../../../../types/support";

/**
 * RMA 규격 검색 모달
 * @param props
 * @returns
 */
const SearchStndInner = ({
                             confirmCallback,
                             cancelCallback,
                             modalDepth,
                         }: ModalInnerConfirmType<StdType>) => {
    const defaultSearchValue = {
        limit: 10,
        pageNo: 1,
        keyword: "",
    };

    const {handleModal, resetModal} = useModal();

    const [searchOption, setSearchOption] =
        useState<BasicSearchType>(defaultSearchValue);

    const [selectItem, setSelectItem] = useState<StdType | null>(null);

    const {data} = useReadStnd(searchOption);

    const {register, handleSubmit} = useForm({
        defaultValues: searchOption,
    });

    const onSubmit: SubmitHandler<BasicSearchType> = (submitData) => {
        setSearchOption(submitData);
    };

    const onClose = () => {
        resetModal(modalDepth);
    };

    const onConfirm = () => {
        if (selectItem) {
            confirmCallback(selectItem);
            onClose();
        } else {
            handleModal({
                isOpen: true,
                contents: "규격을 선택해주세요.",
                type: "alert",
                depth: modalDepth + 1,
            });
        }
    };

    const onCancel = () => {
        onClose();
        cancelCallback && cancelCallback();
    };

    return (
        <>
            <form className="d-flex mb-15px" onSubmit={handleSubmit(onSubmit)}>
                <input
                    type="text"
                    className="form-control w-250px ms-5px h-34px"
                    {...register("keyword")}
                />
                <button type="submit" className="btn btn-info btn_search w-80px ms-5px">
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                        alt=""
                    />
                    조회
                </button>
            </form>

            <table className="table table-bordered my_table table_modal">
                <thead>
                <tr>
                    <th style={{width: "7.1%"}}></th>
                    <th>이름</th>
                </tr>
                </thead>
                <tbody>
                {(data?.stndList ?? [])?.length === 0 ? (
                    <EmptyTableRow/>
                ) : (
                    (data?.stndList ?? [])?.map((item: StdType) => {
                        return (
                            <tr className={`clickable ${item.newTxtStndItem === selectItem?.newTxtStndItem ? "lightblue" : ""}`}
                                onClick={() => setSelectItem(item)}>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            checked={
                                                selectItem?.newTxtStndItem === item?.newTxtStndItem
                                            }
                                            onClick={() => setSelectItem(item)}
                                        />
                                    </div>
                                </td>
                                <td className="text-start">{item?.newTxtStndItem ?? "-"}</td>
                            </tr>
                        );
                    })
                )}
                </tbody>
            </table>

            <PaginationSub
                totalCount={data?.totalCount ?? 0}
                currentPage={Number(searchOption.pageNo)}
                onChangeCallback={(i) =>
                    setSearchOption({...searchOption, pageNo: i})
                }
            />

            <div className="mt-3 d-flex align-items-center justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary w-100px h-38px my-0"
                    onClick={onCancel}
                >
                    취소
                </button>
                <button
                    type="button"
                    className="btn btn-dark w-100px h-38px my-0 ms-3"
                    onClick={onConfirm}
                >
                    선택
                </button>
            </div>
        </>
    );
};

export default SearchStndInner;
